import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Client } from '../models/client';
import { environment } from 'src/environments/environment';
import { ClientCategory } from '../models/clientCategory';
import { UserService } from './user.service';
import { Representative } from '../models/representative';

@Injectable()
export class DeliveryService {
  public url: string;
  public urlIMFEL: string;
  public urlCuiIMFEL: string;

  constructor(private _http: HttpClient,  private userService: UserService) {
    this.url = environment.apiUrl;
    this.urlIMFEL = environment.apiIMFEL;
  }

  // GET ALL REPRESENTATIVE
  getAll(): Promise<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http
      .get(this.url + 'erpbackendint-delivery', { headers: headers })
      .toPromise();
  }

  // INSERT CLIENT
  insertDelivery(delivery): Promise<any> {
    let params = JSON.stringify(delivery);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(this.url + 'erpbackendint-delivery/', params, { headers: headers }).toPromise();
  }

  // UPDATE CLIENT
  update(client: Client): Promise<any> {
    let params = JSON.stringify(client);
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(this.url + 'erpbackendint-delivery/', params, { headers: headers }).toPromise();
  }  
}
